import useBootstrapData from './useBootstrapData';

export default function useLobbyUrl(): string | undefined {
  const bootstrapData = useBootstrapData();
  return bootstrapData?.lobby_url;
}
